/**
 * @author：
 * @update：
 * @description：
 **/
import {detailGood,fileUp,fileEcho,goodsClass,shopClassParent,downList,GoodsPass} from "../../api/url";
export default {
    data() {
        return {
            fileEcho:fileEcho,
            storeName:'',//店铺名称
            goodsName:'',//商品名称
            goodsClassName:[],//商品分类
            uploadImgList:[],//商品主图
            videoLocation:'',//视频地址
            goodsImgList:[],//商品宣传图
            goodsImgList2:[],//商品宣传图
            tableData:[],//作品列表
            goodsDescribe:'',//商品描述
            saleData: [],//销售信息列表
            shopClassValue:[],//店铺中的分类
            payType:'',//支付方式
            bargaining:'',//是否议价
            stockNumber:'',//库存计数
            invoice:'',//发票服务
            restrictionsNumber:'',//购买数量
            restrictionsNum:'',//购买数
            regularSale:false,//定时开售是否显示
            regularSaleTime:'',//定时开售
            deliveryTime:'',//发货时间
            logisticsType:'',//配送方式
            express:'',//是否包邮
            freight:'',//运费
            editorHtml:'',//图文描述
            launchTime:'',//过审后上架类型
            launchTimeVal:'',//过审后上架具体时间
            attributeValues:[],//类目属性
            audits:[],//审核记录
            violationList:[],//违规下架记录
            goodsState:'',//当前的商品状态
            downWrapBol:false,//违规下架
            downId:'',//下架id
            cause:'',//违规原因
            examineVal:'审核通过',//审核单选
            examineText:'',//不通过原因
        };
    },
    // 自定义方法
    methods: {
        details(id){
            this.$ajax.get(detailGood(id)).then(res=>{
                console.log(res);
                this.goodsState = res.data.auditState;
                this.storeName = res.data.store.name;//店铺名称
                this.goodsName=res.data.name;//商品名称
                this.goodsDescribe=res.data.description;//描述
                this.storeId=res.data.store.id;//店铺id
                this.region=res.data.store.region;//店铺地址
                this.tableData = [res.data.work];//作品信息
                this.attributeValues = res.data.attributeValues;//类目属性
                if(res.data.images!=undefined&&res.data.images.length>0){
                    let arr = [];
                    for(let i = 0; i < res.data.images.length; i++){
                        arr.push(fileEcho+res.data.images[i].location)
                    }
                    this.uploadImgList = arr
                }
                if(res.data.posters!=undefined&&res.data.posters.length>0){
                    let arr = [];
                    let arr2 = [];
                    for(let i = 0; i < res.data.posters.length; i++){
                        arr2.push(fileEcho+res.data.posters[i].location);
                        arr.push({src:fileEcho+res.data.posters[i].location,label:res.data.posters[i].label});
                    }
                    this.goodsImgList = arr;
                    this.goodsImgList2  = arr2;
                }
                if(res.data.content!=undefined&&res.data.content.content!=undefined){
                    this.editorHtml = res.data.content.content;//富文本回显
                }
                if(res.data.video!=undefined){
                    this.videoLocation = fileEcho+res.data.video.content.location;//视频
                }
                this.payType=res.data.pricing;//付款方式
                this.bargaining = res.data.bargain;//是否议价
                this.stockNumber = res.data.stockControl;//库存计数
                this.invoice = res.data.invoicePolicy;//发票服务
                this.restrictionsNumber = res.data.restricted;//是否限购
                if(res.data.restricted!=undefined){
                    this.restrictionsNum = res.data.limitedQuantity;//限购数量
                }
                this.other = res.data.regularSale;//定时开售
                if(res.data.regularSale==true){//定时开售
                    this.regularSale = true;
                    if(res.data.regularSale!=undefined){
                        this.regularSaleTime = res.data.regularSaleTime;//定时开售时间
                    }
                }

                this.deliveryTime = res.data.deliveryPolicy;//发货时间
                this.logisticsType = res.data.deliveryMode;//配送方式
                if(res.data.deliveryMode=="EXPRESS"){
                    this.express = res.data.freePostage;//是否包邮
                    if(res.data.freePostage==false){
                        this.freight = res.data.postage;//运费
                    }
                }
                this.launchTime = res.data.action;//上架时间
                if(res.data.action=="TIMING"){
                    this.launchTimeVal = res.data.timedForSaleTime;
                }
                let Arr = [];//商品销售规格列表
                for(let i = 0; i < res.data.skus.length; i++){
                    //10createdDate
                    let obj = {};
                    for(let j = 0; j < res.data.skus[i].specifications.length; j++){
                        // let key = res.data.skus[i].specifications[j].specificationTemplateId+'createdDate';
                        let key = res.data.skus[i].specifications[j].name;
                        obj[key]=res.data.skus[i].specifications[j].value;
                        obj.id=res.data.skus[i].id;
                        obj.faced = res.data.skus[i].faced;
                        obj.nameSkus=res.data.skus[i].name;
                        obj.descriptionSkus=res.data.skus[i].description;
                        obj.originalPriceSkus=res.data.skus[i].originalPrice;
                        obj.priceSkus=res.data.skus[i].price;
                        obj.stookSkus=res.data.skus[i].stock;
                        obj.uniqueSkus=res.data.skus[i].unique;
                    }
                    Arr.push(obj)
                }
                this.saleData = Arr;
                this.$ajax.get(goodsClass(res.data.classification.id),{id:res.data.classification.id}).then(res2=>{
                    let arr = [];
                    arr.unshift(res2.data.name);
                    let parent = res2.data.parent;
                    if(parent!=undefined){
                        arr.unshift(parent.name);
                        if(parent.parent!=undefined){
                            arr.unshift(parent.parent.name);
                        }
                    }
                    this.goodsClassName = arr;
                },err=>{
                    console.log(err);
                })
                if(res.data.storeCategories.length>0&&res.data.storeCategories!=undefined){
                    let dataArr = [];
                    for(let i = 0; i < res.data.storeCategories.length; i++){
                        let arr = [];
                        this.$ajax.get(shopClassParent(res.data.storeCategories[i].id),{id:res.data.storeCategories[i].id}).then(res=>{
                            this.forParent(res.data,arr)
                            dataArr.push(arr);
                            console.log(res);
                        },err=>{
                            console.log(err);
                        });
                        if(i == res.data.storeCategories.length-1){
                            setTimeout(function(){
                                this.shopClassValue = dataArr;
                            }.bind(this),500)
                        }
                    }
                }
                if(res.data.audits!=undefined){
                    this.audits = res.data.audits;
                }
                if(res.data.haltSaleRecords!=undefined){
                    this.violationList = res.data.haltSaleRecords
                }
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:"error",
                    center:true,
                    duration:3000
                })
            })
        },
        forParent(data,arr) {
            arr.unshift(data.name);
            if(data.parent){
                this.forParent(data.parent,arr)
            }else{
                return arr
            }
        },
        //违规下架商品
        downGoods(){
            if(this.cause==''){
                this.$message({
                    showClose:true,
                    message:"请填写违规下架的原因",
                    type:"error",
                    center:true,
                    duration:3000
                })
                return false
            }
            let data = {
                id : this.downId,
                cause:this.cause
            };
            this.$ajax.put(downList(this.downId),data).then(res=>{
                console.log(res);
                this.downId='';
                this.downWrapBol=true;
                this.cause='';
                this.$message({
                    showClose:true,
                    message:"下架成功",
                    type:"success",
                    center:true,
                    duration:3000
                })
                this.$router.go(-1)
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:"error",
                    center:true,
                    duration:3000
                })
            })
        },
        //审核商品
        pass(){
            let data = {
                spuId:this.downId,
                pass:this.examineVal=='审核通过'?true:false,
            }
            if(this.examineVal=="审核不通过"){
                if(this.examineText==''){
                    this.$message({
                        showClose:true,
                        message:"请填写审核不通过原因",
                        type:"error",
                        center:true,
                        duration:3000
                    })
                    return false
                }else{
                    data.opinion = this.examineText
                }
            }
            this.$ajax.post(GoodsPass(this.downId),data).then(res=>{
                console.log(res);
                this.$message({
                    showClose:true,
                    message:"已审核",
                    type:"success",
                    center:true,
                    duration:3000
                })
                this.$router.go(-1)
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:"error",
                    center:true,
                    duration:3000
                })
            })
        },
        //审核员
        returnUserInfo(userInfo){
            let name = '--';
            if(userInfo.type=="ENTERPRISE"){
                name = userInfo.legalPerson;
            }else{
                if(userInfo.state=="CERTIFIED"){
                    name = userInfo.realName
                }else{
                    name = userInfo.nickname
                }
            }
            return name
        },
    },
    // 数据观察监听
    watch: {},
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {
        this.downId = this.$route.query.id
    },
    // 组件挂载完成之前
    beforeMount() {
        this.details(this.$route.query.id)
    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
